import {
	ignoreErrors,
	isCorsError,
	isResponseStatus,
	rezaTemplatePortalInfoQuery,
	useAxiosCmsInstance,
	usePoQuery,
} from '@gov-nx/api';
import { useAppLanguage } from '@gov-nx/core/hooks';

export const usePortalInfo = (templateId?: string) => {
	const { axiosCmsInstance } = useAxiosCmsInstance();
	const { language } = useAppLanguage();
	const errorIgnoreFilter = ignoreErrors(isCorsError, isResponseStatus(404));

	const query = usePoQuery(
		{
			queryKey: ['reza', 'portal-info', language, templateId],
			enabled: !!templateId,
			queryFn: async () =>
				templateId
					? rezaTemplatePortalInfoQuery(axiosCmsInstance, templateId, language)
					: undefined,
			retry: false,
		},
		{ errorIgnoreFilter }
	);

	return {
		isError: query.error ? !errorIgnoreFilter(query.error) : false,
		isLoading: query.isLoading,
		data: query.data,
	};
};
